import { DcaStrategy } from "@/types/dca";
import { create } from "zustand";

type State = {
  dcaStrategyCreate: DcaStrategy;
  dcaStrategyDetail: DcaStrategy;
  listDcaStrategy: DcaStrategy[];
  toDcaWallet: DcaStrategy | null;
  refresh: number,
  setRefresh: (time: number) => void;
  setDcaStrategyCreate: (detail: DcaStrategy) => void;
  setDcaStrategyDetail: (detail: DcaStrategy) => void;
  setListDcaStrategy: (detail: DcaStrategy[]) => void;
  setToDcaWallet: (detail: DcaStrategy | null) => void;
};

export const useDcaStrategyStore = create<State>((set) => ({
  dcaStrategyCreate: {} as DcaStrategy,
  dcaStrategyDetail: {} as DcaStrategy,
  listDcaStrategy: [],
  toDcaWallet: null,
  refresh: 0,
  setRefresh: (time: number) => {
    set({ refresh: time });
  },
  setDcaStrategyCreate: (detail: DcaStrategy) => set({ dcaStrategyCreate: detail }),
  setDcaStrategyDetail: (detail: DcaStrategy) => set({ dcaStrategyDetail: detail }),
  setListDcaStrategy: (detail: DcaStrategy[]) => set({ listDcaStrategy: detail }),
  setToDcaWallet: (detail: DcaStrategy | null) => set({ toDcaWallet: detail }),
}));